import { useGetApplication } from 'app/hooks';

import { type EconomyActivity } from '../models/economyActivity.model';
import { baseUrl } from '../services/economyActivity.service';

export const useOperationsList = (ignoreDefaultLang?: boolean) => {
  const response = useGetApplication<Array<EconomyActivity>>({
    url: baseUrl,
    params: {},
    headers: ignoreDefaultLang ? { lang: true } : undefined
  });

  return response;
};
